export const FETCH_ERROR = `Sorry, we can't connect to the server.`;
